module.exports = __webpack_public_path__ + "fonts/a4cf5ee9c871a4a64387afba2993a653.svg";